module.exports = __webpack_public_path__ + "static/media/clinician-desktop.944fefb5.svg";